module.exports = __webpack_public_path__ + "static/logosHorizontal_Part2-0bdf66a7cb8a4fd07a5ad658fedb7827.png";